import { Directive } from '@angular/core';
import { BaseComponent } from './base.component';

@Directive()
export abstract class BaseFileUploadComponent extends BaseComponent {
  dragging: boolean = false;

  protected abstract handleFileInput(files: FileList): void;

  onDragOver(event: DragEvent): void {
    event.stopPropagation();
    event.preventDefault();
    this.dragging = true;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();

    if (event.dataTransfer) {
      this.handleFileInput(event.dataTransfer.files);
    }

    this.dragging = false;
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.dragging = false;
  }
}
